import { Activity, BarChart3, ClipboardList, Compass, FileText, Fuel, Network, Settings, ShieldCheck, Ship, UserRound, type LucideIcon } from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  shortLabel?: string;
  icon: LucideIcon;
  end?: boolean;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "Operate",
    items: [
      { to: "/", label: "Today", icon: Activity, end: true },
      { to: "/plan", label: "Plan", icon: Compass },
      { to: "/execution", label: "Underway", icon: ClipboardList },
      { to: "/performance", label: "Performance", shortLabel: "Perf", icon: BarChart3 },
      { to: "/energy", label: "Energy / SEEMP", shortLabel: "SEEMP", icon: Fuel },
      { to: "/reports", label: "Reports", icon: FileText },
    ],
  },
  {
    label: "Manage",
    items: [
      { to: "/office", label: "Office", icon: UserRound },
      { to: "/audit", label: "Audit", icon: ShieldCheck },
      { to: "/ecosystem", label: "Ecosystem", shortLabel: "Eco", icon: Network },
      { to: "/profile", label: "Profile", icon: Settings },
    ],
  },
];

export function flatNavItems(groups: NavGroup[] = NAV_GROUPS): NavItem[] {
  return groups.flatMap((group) => group.items);
}

export function mobileNavLabel(item: NavItem): string {
  return item.shortLabel ?? item.label;
}

export { Ship };
